if (!customElements.get('revo-mega-scroll')) {
  customElements.define('revo-mega-scroll', class extends HTMLElement {
    connectedCallback() {
      this.menu = this.closest('.mega-menu');
      this.navigation = this.closest('desktop-navigation');
      if (!this.menu || !this.navigation) return;
      this.abort = new AbortController();
      const update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (this.menu.hasAttribute('hidden')) return;
          const viewport = window.visualViewport;
          const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
          const top = this.menu.getBoundingClientRect().top;
          this.style.setProperty('--rm-available-height', Math.max(0, bottom - top - 12) + 'px');
        });
      };
      const options = {signal:this.abort.signal, passive:true};
      window.addEventListener('resize', update, options);
      window.addEventListener('scroll', update, options);
      window.visualViewport?.addEventListener('resize', update, options);
      this.navigation.addEventListener('desktop-nav:dropdown:open', () => {
        if (!this.menu.hasAttribute('hidden')) {this.scrollTop = 0; update();}
      }, {signal:this.abort.signal});
      this.observer = new MutationObserver(() => {
        if (!this.menu.hasAttribute('hidden')) {this.scrollTop = 0; update();}
      });
      this.observer.observe(this.menu, {attributes:true, attributeFilter:['hidden']});
      this.resize = new ResizeObserver(update);
      const header = this.closest('.shopify-section');
      if (header) this.resize.observe(header);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); cancelAnimationFrame(this.frame);
    }
  });
}
